import BaseClass from "../BaseClass.js";

export default class VideoPreloader extends BaseClass {

    constructor(element) {
        super(element);
        this.jqxhr = null;
        this.url = null;
        this.previewholder = null;
        this.imageQuality = 1;
        this.timeOutHandle = null;
        this.lightbox = false;
        this.lightboxIcon = false;
        this.previewType = "video";
        this.loadingSpinnerText = false;
        this.onClickListener = null;
        this.disablePlayButton = false;

        this.init();
    }


    init() {
        this.url = this.$element.attr("data-url");

        let imageQuality = this.$element.attr("data-img-quality");
        if (imageQuality != undefined) {
            this.imageQuality = imageQuality;
        }

        const lightbox = this.$element.attr('data-lightbox');
        if (lightbox != undefined && lightbox == true) {
            this.lightbox = true;
        }

        const lightboxIcon = this.$element.attr('data-lightbox-icon');
        if (lightboxIcon != undefined && lightboxIcon == true) {
            this.lightboxIcon = true;
        }

        const previewType = this.$element.attr('data-preview-type');
        if (previewType != undefined) {
            this.previewType = previewType;
        }

        const loadingSpinnerText = this.$element.attr('data-loading-spinner-text');
        if (loadingSpinnerText != undefined && loadingSpinnerText == true) {
            this.loadingSpinnerText = true;
        }

        // deaktiviert die inline Play Funktion aber zeigt den Button weiterhin an
        const disablePlayButton = this.$element.attr('data-disable-playbutton');
        if (disablePlayButton != undefined) {
            this.disablePlayButton = disablePlayButton;
        }


        // wird benötigt, damit ein klick innerhalb einer gallerie keine lightbox öffnet, alternativ kann das in die gallery.js
        this.onClickListener = function (event) {
            event.stopPropagation();
        }

        this.$element.on('click', this.onClickListener);

        this.loadVideo();
    }


    loadVideo() {
        let mySelf = this;

        this.jqxhr = $.post(this.url, "", function () {
        }, 'json')
            .done(function (jsonData) {

                if (jsonData.success) {
                    if (jsonData.videoUrl != undefined) {
                        mySelf.clearTimeOut();
                        mySelf.createVideoPlayer(jsonData, mySelf.disablePlayButton);
                    } else if (jsonData.image != undefined) {

                        if (mySelf.$element.hasClass('showScreenshot')) {
                            if (jsonData.errorMsg != '') {
                                if (mySelf.$element.hasClass('showError')) {
                                    mySelf.clearTimeOut();
                                } else {
                                    mySelf.clearTimeOut();
                                    const isGalleryItem = Boolean(mySelf.$element.attr('data-gallery-item'));
                                    const isActive = mySelf.$element.hasClass('active');

                                    let $preview = mySelf.templatesWorker.loadVideoPartPreloaderTemplate(
                                        mySelf.url,
                                        jsonData.image,
                                        3,
                                        mySelf.lightboxIcon,
                                        isGalleryItem,
                                        isActive,
                                        jsonData.errorMsg
                                    );
                                    $preview.insertAfter(mySelf.$element);

                                    mySelf.$element.remove();
                                    $(document).trigger("content:loaded");
                                }
                            } else {
                                mySelf.timeOutHandle = setTimeout(function () {
                                    mySelf.loadVideo();
                                }, 1000);
                            }
                        } else {
                            mySelf.clearTimeOut();
                            const isGalleryItem = Boolean(mySelf.$element.attr('data-gallery-item'));
                            const isActive = mySelf.$element.hasClass('active');

                            let $preview = mySelf.templatesWorker.loadVideoPartPreloaderTemplate(
                                mySelf.url,
                                jsonData.image,
                                3,
                                mySelf.lightboxIcon,
                                isGalleryItem,
                                isActive,
                                jsonData.errorMsg
                            );
                            $preview.insertAfter(mySelf.$element);

                            mySelf.$element.remove();
                            $(document).trigger("content:loaded");
                        }
                    }
                } else {
                    mySelf.timeOutHandle = setTimeout(function () {
                        mySelf.loadVideo();
                    }, 1000);
                }

            });
    }

    createVideoPlayer(jsonData) {

        const isGalleryItem = Boolean(this.$element.attr('data-gallery-item'));
        const isActive = this.$element.hasClass('active');

        if (this.previewType == "image") {

            let $autosizeimage = this.templatesWorker.loadAutoSizeImageTemplate(
                jsonData.image,
                1,
                this.lightbox,
                false,
                false,
                false,
                this.loadingSpinnerText
            );

            $autosizeimage.insertAfter(this.$element);

        } else {
            let $video = this.templatesWorker.loadVideoplayerTemplate(
                jsonData.videoUrl,
                jsonData.image,
                3,
                this.lightbox,
                this.lightboxIcon,
                isGalleryItem,
                isActive,
                false,
                this.loadingSpinnerText,
                this.disablePlayButton
            );

            $video.insertAfter(this.$element);
        }

        this.$element.remove();
        $(document).trigger("content:loaded");
    }

    destroyListener() {
        this.clearTimeOut();

        this.$element.off('click', this.onClickListener);
    }

    clearTimeOut() {
        if (this.timeOutHandle != null) {
            clearTimeout(this.timeOutHandle);
            this.timeOutHandle = null;
        }
    }

}